// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19pd_","expireSoon":"styles_expireSoon__3vCIA"};